/** Looks at the hostname to determine if we're on the churchx.online domain */
export const isChurchX = window.location.hostname === "churchx.online";
